import { makeStyles, tokens } from '@fluentui/react-components';

export const useDefaultModalStyles = makeStyles({
    button: {
        height: '32px',
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase300,
        fontFamily: 'Segoe UI',
    },
    content: {
        maxWidth: '550px',
        fontSize: '12px',
    },
});
